import { Navigate, createFileRoute } from "@tanstack/react-router";
import { ClientsWorkspace } from "../components/admin/clients-workspace";
import { useAuth } from "../stores/auth";

export const Route = createFileRoute("/admin/clients/")({
  component: AdminClientsPage,
});

function AdminClientsPage() {
  const user = useAuth((state) => state.user);
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;
  return <ClientsWorkspace />;
}
